"use client";

import { c as _c } from "react/compiler-runtime";
import NextImage from "next/image";
import type React from "react";
import { RichText } from "@/components/pop-ui/rich-text";
import { Button } from "@/components/ui/button";
import LocaleLink from "@/lib/i18n/locale-link";
import type { CMSButtonData, CMSButtonGroupData, CMSImageData, CMSLinkData, CMSMediaData, CMSPlatformLinkData, Translatable } from "../types";
import { getCollectionUrl, getImageUrlByDevice, useTranslatedText } from "../utils";
export const CMSText = t0 => {
  const $ = _c(3);
  const {
    text,
    className
  } = t0;
  const translatedText = useTranslatedText(text);
  let t1;
  if ($[0] !== className || $[1] !== translatedText) {
    t1 = <span className={className}>{translatedText}</span>;
    $[0] = className;
    $[1] = translatedText;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
// 链接组件
export const CMSLink = t0 => {
  const $ = _c(24);
  const {
    link,
    children,
    className
  } = t0;
  if (!link || link.type === "none") {
    let t1;
    if ($[0] !== children) {
      t1 = <>{children}</>;
      $[0] = children;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  const t1 = link.target === "_blank" ? "_blank" : undefined;
  const t2 = link.target === "_blank" ? "noopener noreferrer" : undefined;
  let t3;
  if ($[2] !== className || $[3] !== t1 || $[4] !== t2) {
    t3 = {
      className,
      target: t1,
      rel: t2
    };
    $[2] = className;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const commonProps = t3;
  if (link.type === "internal" && link.internalUrl) {
    const href = link.internalUrl.startsWith("/") ? link.internalUrl : `/${link.internalUrl}`;
    let t4;
    if ($[6] !== children || $[7] !== commonProps || $[8] !== href) {
      t4 = <LocaleLink href={href} {...commonProps}>{children}</LocaleLink>;
      $[6] = children;
      $[7] = commonProps;
      $[8] = href;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    return t4;
  }
  if (link.type === "collection" && link.collectionId) {
    let t4;
    if ($[10] !== link.collectionId) {
      t4 = getCollectionUrl(link.collectionId);
      $[10] = link.collectionId;
      $[11] = t4;
    } else {
      t4 = $[11];
    }
    const collectionUrl = t4;
    if (collectionUrl) {
      let t5;
      if ($[12] !== children || $[13] !== collectionUrl || $[14] !== commonProps) {
        t5 = <LocaleLink href={collectionUrl} {...commonProps}>{children}</LocaleLink>;
        $[12] = children;
        $[13] = collectionUrl;
        $[14] = commonProps;
        $[15] = t5;
      } else {
        t5 = $[15];
      }
      return t5;
    }
  }
  if (link.type === "external" && link.externalUrl) {
    try {
      new URL(link.externalUrl);
      let t4;
      if ($[16] !== children || $[17] !== commonProps || $[18] !== link.externalUrl) {
        t4 = <a href={link.externalUrl} {...commonProps}>{children}</a>;
        $[16] = children;
        $[17] = commonProps;
        $[18] = link.externalUrl;
        $[19] = t4;
      } else {
        t4 = $[19];
      }
      return t4;
    } catch {
      let t4;
      if ($[20] !== children) {
        t4 = <>{children}</>;
        $[20] = children;
        $[21] = t4;
      } else {
        t4 = $[21];
      }
      return t4;
    }
  }
  let t4;
  if ($[22] !== children) {
    t4 = <>{children}</>;
    $[22] = children;
    $[23] = t4;
  } else {
    t4 = $[23];
  }
  return t4;
};
// 端跳转链接组件
export const CMSPlatformLink = t0 => {
  const $ = _c(23);
  const {
    platformLink,
    children,
    className
  } = t0;
  if (!platformLink || platformLink.type === "none") {
    let t1;
    if ($[0] !== children) {
      t1 = <>{children}</>;
      $[0] = children;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  const t1 = platformLink.target === "_blank" ? "_blank" : undefined;
  const t2 = platformLink.target === "_blank" ? "noopener noreferrer" : undefined;
  let t3;
  if ($[2] !== className || $[3] !== t1 || $[4] !== t2) {
    t3 = {
      className,
      target: t1,
      rel: t2
    };
    $[2] = className;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const commonProps = t3;
  let t4;
  if ($[6] !== platformLink.collectionId || $[7] !== platformLink.type || $[8] !== platformLink.webUrl) {
    t4 = () => {
      if (platformLink.type === "collection" && platformLink.collectionId) {
        return getCollectionUrl(platformLink.collectionId);
      }
      if (platformLink.webUrl) {
        return platformLink.webUrl;
      }
    };
    $[6] = platformLink.collectionId;
    $[7] = platformLink.type;
    $[8] = platformLink.webUrl;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const getTargetUrl = t4;
  let t5;
  let t6;
  if ($[10] !== children || $[11] !== commonProps || $[12] !== getTargetUrl || $[13] !== platformLink.target || $[14] !== platformLink.type) {
    t6 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const targetUrl = getTargetUrl();
      if (!targetUrl) {
        let t7;
        if ($[17] !== children) {
          t7 = <>{children}</>;
          $[17] = children;
          $[18] = t7;
        } else {
          t7 = $[18];
        }
        t6 = t7;
        break bb0;
      }
      const isInternalLinkSameWindow = platformLink.type === "collection" || platformLink.type === "internal" && platformLink.target !== "_blank" && targetUrl.startsWith("/") && !targetUrl.startsWith("//");
      if (isInternalLinkSameWindow) {
        const href = targetUrl.startsWith("/") ? targetUrl : `/${targetUrl}`;
        t6 = <LocaleLink href={href} {...commonProps}>{children}</LocaleLink>;
        break bb0;
      }
      t5 = platformLink.type === "internal" && targetUrl.startsWith("/") ? targetUrl : targetUrl;
    }
    $[10] = children;
    $[11] = commonProps;
    $[12] = getTargetUrl;
    $[13] = platformLink.target;
    $[14] = platformLink.type;
    $[15] = t5;
    $[16] = t6;
  } else {
    t5 = $[15];
    t6 = $[16];
  }
  if (t6 !== Symbol.for("react.early_return_sentinel")) {
    return t6;
  }
  const finalUrl = t5;
  let t7;
  if ($[19] !== children || $[20] !== commonProps || $[21] !== finalUrl) {
    t7 = <a href={finalUrl} {...commonProps}>{children}</a>;
    $[19] = children;
    $[20] = commonProps;
    $[21] = finalUrl;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  return t7;
};
// 图片组件
export const CMSImage = t0 => {
  const $ = _c(14);
  const {
    image,
    className,
    width,
    height,
    priority
  } = t0;
  const altText = useTranslatedText(image?.alt);
  let t1;
  if ($[0] !== image) {
    t1 = getImageUrlByDevice(image);
    $[0] = image;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const imageUrl = t1;
  if (!imageUrl) {
    return null;
  }
  let t2;
  if ($[2] !== height || $[3] !== width) {
    t2 = width && height ? {
      width,
      height
    } : {
      fill: true,
      style: {
        objectFit: "cover" as const
      },
      sizes: "(max-width: 768px) 100vw, 50vw"
    };
    $[2] = height;
    $[3] = width;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const imageProps = t2;
  const t3 = altText || "";
  let t4;
  if ($[5] !== className || $[6] !== imageProps || $[7] !== imageUrl || $[8] !== priority || $[9] !== t3) {
    t4 = <NextImage src={imageUrl} alt={t3} className={className} priority={priority} unoptimized={true} {...imageProps} />;
    $[5] = className;
    $[6] = imageProps;
    $[7] = imageUrl;
    $[8] = priority;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== className || $[12] !== t4) {
    t5 = <div className={className}>{t4}</div>;
    $[11] = className;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};
// 媒体组件
export const CMSMedia = t0 => {
  const $ = _c(12);
  const {
    media,
    imageProps,
    videoProps,
    className
  } = t0;
  if (!media) {
    return null;
  }
  if (media.type === "image" && media.imageUrl) {
    let t1;
    if ($[0] !== media.alt || $[1] !== media.imageUrl) {
      t1 = {
        pcUrl: media.imageUrl,
        mobUrl: media.imageUrl,
        alt: media.alt
      };
      $[0] = media.alt;
      $[1] = media.imageUrl;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    let t2;
    if ($[3] !== className || $[4] !== imageProps || $[5] !== t1) {
      t2 = <CMSImage image={t1} {...imageProps} className={className} />;
      $[3] = className;
      $[4] = imageProps;
      $[5] = t1;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    return t2;
  }
  if (media.type === "video" && media.videoUrl) {
    let t1;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = {
        width: "100%",
        height: "auto"
      };
      $[7] = t1;
    } else {
      t1 = $[7];
    }
    let t2;
    if ($[8] !== className || $[9] !== media.videoUrl || $[10] !== videoProps) {
      t2 = <video controls={true} src={media.videoUrl} {...videoProps} style={t1} className={className}>Your browser does not support the video tag.</video>;
      $[8] = className;
      $[9] = media.videoUrl;
      $[10] = videoProps;
      $[11] = t2;
    } else {
      t2 = $[11];
    }
    return t2;
  }
  return null;
};
// 按钮组件
export const CMSButton = t0 => {
  const $ = _c(26);
  let button;
  let buttonProps;
  if ($[0] !== t0) {
    ({
      button,
      ...buttonProps
    } = t0);
    $[0] = t0;
    $[1] = button;
    $[2] = buttonProps;
  } else {
    button = $[1];
    buttonProps = $[2];
  }
  const buttonText = useTranslatedText(button?.text_trans || button?.text);
  if (!button || !buttonText) {
    return null;
  }
  let t1;
  if ($[3] !== buttonText) {
    t1 = <>{buttonText}</>;
    $[3] = buttonText;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const buttonContent = t1;
  const t2 = button.variant || "default";
  const t3 = button.size || "default";
  let t4;
  if ($[5] !== button.type) {
    t4 = () => {
      if (button.type === "function") {}
    };
    $[5] = button.type;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== buttonProps || $[8] !== t2 || $[9] !== t3 || $[10] !== t4) {
    t5 = {
      variant: t2,
      size: t3,
      onClick: t4,
      ...buttonProps
    };
    $[7] = buttonProps;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const commonButtonProps = t5;
  const useAsChild = button.link && (button.link.type === "internal" || button.link.type === "collection");
  if (button.type === "link" && button.link) {
    const t6 = !useAsChild ? "inline-block" : undefined;
    const t7 = useAsChild ? buttonContent : buttonContent;
    let t8;
    if ($[12] !== button.link || $[13] !== t6 || $[14] !== t7) {
      t8 = <CMSLink link={button.link} className={t6}>{t7}</CMSLink>;
      $[12] = button.link;
      $[13] = t6;
      $[14] = t7;
      $[15] = t8;
    } else {
      t8 = $[15];
    }
    let t9;
    if ($[16] !== commonButtonProps || $[17] !== t8 || $[18] !== useAsChild) {
      t9 = <Button {...commonButtonProps} asChild={useAsChild}>{t8}</Button>;
      $[16] = commonButtonProps;
      $[17] = t8;
      $[18] = useAsChild;
      $[19] = t9;
    } else {
      t9 = $[19];
    }
    return t9;
  } else {
    if (button.type === "function") {
      let t6;
      if ($[20] !== buttonContent || $[21] !== commonButtonProps) {
        t6 = <Button {...commonButtonProps}>{buttonContent}</Button>;
        $[20] = buttonContent;
        $[21] = commonButtonProps;
        $[22] = t6;
      } else {
        t6 = $[22];
      }
      return t6;
    }
  }
  let t6;
  if ($[23] !== buttonContent || $[24] !== commonButtonProps) {
    t6 = <Button {...commonButtonProps} disabled={true}>{buttonContent}</Button>;
    $[23] = buttonContent;
    $[24] = commonButtonProps;
    $[25] = t6;
  } else {
    t6 = $[25];
  }
  return t6;
};
// 富文本组件
export const CMSRichText = t0 => {
  const $ = _c(3);
  const {
    text,
    className
  } = t0;
  const translatedText = useTranslatedText(text);
  let t1;
  if ($[0] !== className || $[1] !== translatedText) {
    t1 = <RichText content={translatedText} className={className} />;
    $[0] = className;
    $[1] = translatedText;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};

// 按钮组组件
export const CMSButtonGroup = t0 => {
  const $ = _c(5);
  const {
    buttonGroup,
    className
  } = t0;
  if (!buttonGroup || !buttonGroup.hasButtons || !buttonGroup.buttons?.length) {
    return null;
  }
  const t1 = `flex flex-wrap gap-2 ${className || ""}`;
  let t2;
  if ($[0] !== buttonGroup.buttons) {
    t2 = buttonGroup.buttons.map(_temp);
    $[0] = buttonGroup.buttons;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = <div className={t1}>{t2}</div>;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};

// 页脚内容组件
export const CmsContentFooter = t0 => {
  const $ = _c(5);
  const {
    data,
    className
  } = t0;
  if (!data) {
    return null;
  }
  const t1 = `mt-4 ${className || ""}`;
  let t2;
  if ($[0] !== data.buttonGroup) {
    t2 = <CMSButtonGroup buttonGroup={data.buttonGroup} />;
    $[0] = data.buttonGroup;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = <footer className={t1}>{t2}</footer>;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
function _temp(buttonItem, index) {
  return <CMSButton key={`${buttonItem.button?.text}-${index}`} button={buttonItem.button} />;
}